var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAwaitingApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6328_695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C9.53977 0 9.16668 0.373086 9.16668 0.83332V3.33332C9.16668 3.79355 9.53977 4.16664 10 4.16664C10.4602 4.16664 10.8333 3.79355 10.8333 3.33332V1.70781C15.0443 2.12594 18.3333 5.67898 18.3333 10C18.3333 14.6023 14.6023 18.3333 10 18.3333C5.39773 18.3333 1.66668 14.6023 1.66668 10C1.66668 7.84305 2.4884 5.81711 3.93926 4.28043C4.25523 3.94578 4.24008 3.41836 3.90543 3.10242C3.57078 2.78645 3.04336 2.8016 2.72742 3.13625C0.987227 4.9793 0 7.41332 0 10C0 15.5227 4.47727 20 10 20C15.5227 20 20 15.5227 20 10C20 4.47727 15.5227 0 10 0Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41089 10.589C9.73632 10.9145 10.264 10.9145 10.5894 10.589C10.9148 10.2636 10.9148 9.73594 10.5894 9.41051L7.25608 6.07719C6.93065 5.75176 6.403 5.75176 6.07757 6.07719C5.75214 6.40262 5.75214 6.93027 6.07757 7.2557L9.41089 10.589Z",
    fill: "#263238"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6328_695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwaitingApproval);
export default __webpack_public_path__ + "static/media/AwaitingApproval.90f671e8ffe41bf140e79c4f202137f5.svg";
export { ForwardRef as ReactComponent };